import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const EmptyOrderPlaceholder: FC = () => {
    const { t } = useTranslation()

    const placeholderTranslation = t('pos.orderFinalization.cart.emptyOrderPlaceholder', {
        returnObjects: true,
    }) as string | string[]

    const placeholderLines = Array.isArray(placeholderTranslation)
        ? placeholderTranslation
        : [placeholderTranslation]

    return (
        <View style={styles.container}>
            <View style={styles.textContainer}>
                {placeholderLines.map((line, index) => (
                    <Typography.Heading key={`${line}-${index}`} variant="h2" style={styles.text}>
                        {line}
                    </Typography.Heading>
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 16,
    },
    textContainer: {
        gap: 8,
    },
    text: {
        color: ColorEnum.JET_100,
        textAlign: 'center',
    },
})

export default EmptyOrderPlaceholder
